import { render, staticRenderFns } from "./ShareReview.vue?vue&type=template&id=ee651a88&scoped=true"
import script from "./ShareReview.vue?vue&type=script&lang=js"
export * from "./ShareReview.vue?vue&type=script&lang=js"
import style0 from "./ShareReview.vue?vue&type=style&index=0&id=ee651a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee651a88",
  null
  
)

export default component.exports